import React, { useContext } from 'react';
import MetaTags from '../../common/metaTags';

import { PageWrap } from './Styles';
import StickyFooter from '../../bizLanding/components/StickyFooter/StickyFooter';
import Carousel from './components/seoCarousel';
import Description from './components/description/description';
import WhyExpense from './components/whyExpense/whyExpense';
import Benefits from './components/benefits/benefits';
import Features from './components/features/features';
import Faqs from './components/faqs/faqs';
import DisplayContext from 'UtilityComponents/displayContext';
import { pageData } from './config';

const ExpenseApp = ({ isMobile, isLoggedInUser })=> {
	const { titleTxt, description } = pageData;
	const displayName = useContext(DisplayContext).isMobile;
	const isMobileView = isMobile || displayName == 'mobile';

	return (
		<>
			<PageWrap>
				<MetaTags titleTxt={titleTxt} description={description} />
				<Carousel />
				<Description />
				<WhyExpense />
				<Benefits isLoggedInUser={isLoggedInUser} />
				<Features isLoggedInUser={isLoggedInUser} />
				<Faqs isLoggedInUser={isLoggedInUser} />
			</PageWrap>
			{isMobileView && <StickyFooter />}
		</>
	);
};

export default ExpenseApp;
